var render = function render(){var _vm=this,_c=_vm._self._c;return _c('category-page',{attrs:{"resource-params":_vm.resourceParams,"available-filters":_vm.availableFilters,"header-image":_vm.headerImage,"translated-description":_vm.category.slug === 'free'
      ? _vm.$t('categories.free.description')
      : _vm.$t('categories.premium.description')}})
}
var staticRenderFns = []

export { render, staticRenderFns }